/* 🤖 this file was generated by svg-to-ts */
export const matIconHdrWeak: {
  name: 'hdr-weak';
  data: string;
} = {
  name: 'hdr-weak',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M5 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm12-2c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"/></svg>`
};
